import styled from 'styled-components';
import { colors } from 'styles/colors';

export const TooltipContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const TooltipRow = styled.div`
  display: flex;
  gap: 8px;

  & > span {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${colors.text['main-900']};
  }

  & > span:nth-of-type(2) {
    margin-left: auto;
  }
`;
